module.exports = __webpack_public_path__ + "c48e401e9f4913b97e1fac1f49ccb29e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/addsub.png
// module id = 312
// module chunks = 0